import { css } from 'styled-components'
import { sizes } from './settings'

/**
 * Function checks the response status and returns
 * an error if the response status was not success.
 *
 * @param {Response} response
 * @return {Response|Error}
 */
export const checkStatus = ( response ) => {
  if ( response.status >= 200 && response.status < 300 ) {
    return response
  } else {
    var error = new Error( response.statusText )
    error.response = response
    throw error
  }
}

/**
 * Function parses the JSON body from the Response object.
 *
 * @param {Response} response
 * @return {object}
 */
export const parseJSON = ( response ) => response.json()

/**
 * Function checks if the given value is empty.
 *
 * @param {mixed} value
 * @return {boolean} True if the value was empty, otherwise false.
 */
export const empty = ( value ) => value === null || value.length === 0

/**
 * TODO
 */
export const unique = ( arr ) => {
  let res = []
  let set = new Set()
  arr.forEach(( item ) => {
    set.add( JSON.stringify( item ))
  })
  set.forEach(( item ) => {
    res.push( JSON.parse( item ))
  })
  return res
}

export const media = Object.keys( sizes ).reduce(( acc, label ) => {
  acc[label] = ( ...args ) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css( ...args )}
    }
  `

  return acc
}, {})


/**
 * Calculate percentage ratio between with and height.
 *
 * @param {int} width
 * @param {int} height
 * @return {float}
 */
export const ratio = ( width, height ) => {
  return height / width * 100
}

/**
 * Get space area range in string.
 *
 * @param {array} spaces
 * @return {string}
 */
export const getSpaceAreaRange = ( spaces ) => {
  if ( spaces.length === 0 ) { return }
  const areas = spaces.map(( space ) => space.area )
  const min = Math.min( ...areas )
  const max = Math.max( ...areas )
  if ( min === max ) {
    return `${min} m²`
  } else {
    return `${min} - ${max} m²`
  }
}

/**
 *
 * @param {string} resultId
 * @param {array} properties
 * @return {array}
 */
export const getPropertyImages = ( resultId, images ) => {
  const item = images.filter(( item ) => item.id === resultId ).shift()
  let result = []
  if ( item && item.featured_image ) {
    result.push( item.featured_image )
  }
  if ( item && item.images ) {
    result = result.concat( item.images )
  }
  return result
}

/**
 * Get the property post type slug based
 * on the current locale.
 *
 * @param {string} locale
 */
export const getPropertyPostTypeSlug = ( locale ) => {
  return locale === 'fi' ? 'kiinteisto' : `${locale}/property`
}
